import { ToastContainer } from "react-toastify";
import CheckedLoggedIn from "./Kryzen Alpha App/Routes/checked_loggedIn";
import { initializePushManager } from "./Kryzen Alpha App/pushNotifications/smPushNotification";
import SideBar from "./Kryzen Alpha App/Pages/Side Bar/side_bar";
import { useSelector } from "react-redux";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router";
import { Toast } from "./Kryzen Alpha App/CustomComponent/toast";
import performRequest from "./Kryzen Alpha App/api/request";
import { LeadInfo } from "./Kryzen Alpha App/SchemaInfo/info";
import { CustomErrorResponse } from "./Kryzen Alpha App/CustomComponent/custom_error_response";
import {
  newLeadAlerts,
  buttonTexts,
  greetingWithNames,
} from "./Kryzen Alpha App/Components/Functions/notification_lead_alert";

function App() {
  // Create channel at top of App.js
  const channel = new BroadcastChannel("timer_channel");

  // listen for stop signal
  // new deployment
  useEffect(() => {
    channel.onmessage = (event) => {
      if (event.data === "STOP_TIMER") {
        stopTimer();
      }
    };
    return () => channel.close();
  }, []);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const Role = useSelector((store) => store?.login?.user?.Role);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const store = useSelector((store) => store.login.user);
  const timerRef = useRef(null);

  const [timeLeft, setTimeLeft] = useState(0); // Match autoClose (20s)
  const [notificationData, setNotificationData] = useState(null);
  const [leadClicked, setLeadClicked] = useState(false);
  const [alert] = useState(
    newLeadAlerts[Math.floor(Math.random() * newLeadAlerts.length)]
  );
  const [btnText] = useState(
    buttonTexts[Math.floor(Math.random() * buttonTexts.length)]
  );
  const [greetingWithName] = useState(
    greetingWithNames[Math.floor(Math.random() * greetingWithNames.length)]
  );

  const navigate = useNavigate();
  useEffect(() => {
    const userId = store?.UserId;
    if (
      Role !== process.env.REACT_APP_ROLE_SALLE &&
      Role !== process.env.REACT_APP_ROLE_SALLE_ADMIN
    ) {
      return;
    }

    const duserId = userId || "dummyUserId";

    initializePushManager(duserId, setIsSubscribed);
    const messageHandler = (event) => {
      if (event.data && event.data.type === "INVOKE_NOTIFICATION_FUNCTION") {
        handleNotification(
          event.data.title,
          event.data.body,
          event.data.url,
          event.data.email,
          event.data.name,
          event.data.mobileNumber,
          event.data.origin
        );
      }
    };

    // Add message listener
    navigator.serviceWorker.addEventListener("message", messageHandler);

    // Cleanup to remove listener on unmount
    return () => {
      navigator.serviceWorker.removeEventListener("message", messageHandler);
    };
  }, []);

  const stopTimer = () => {
    clearInterval(timerRef.current);
    setTimeLeft(0);
  };

  const Timer = () => {
    useEffect(() => {
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            let btn = document.getElementById("btn-close-2");
            btn?.click();
            handleHitRequest();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timerRef.current);
    }, []);

    return <span className="toast-timer">Closes in {timeLeft}s</span>;
  };

  const AddAndAssignLead = async (values) => {
    stopTimer();
    setLeadClicked(true);
    channel.postMessage("STOP_TIMER");
    let lead = {
      ...LeadInfo,
      first_name: values.firstName || values.fullName || "",
      last_name: values.lastName || "",
      interestedIn: [],
      full_name: getName(values),
      services: "",
      planned_area: "",
      location_type: "",
      company_name: values.businessName || "",
      origin: "enquiry",
      lead_alloted_to: store.UserId || "",
      reAssignTo: store.Name || "",
      preferred_contact_method: "",
      contact_number: values.mobileNumber || values?.whatsappNumber || "",
      lead_status: "",
      email: values.email || "",
      gst_number: values.gst_number || "",
      // address: values.address1 || values.address2 || "",
      notes: values.notes || "",
    };

    navigate("/leads/add-new-lead", { state: lead });
    // performRequest("POST", "/leads_v2/create_lead", lead)
    //   .then((res) => {
    //     if (res.status === 201) {
    //       setTimeout(() => {
    //         Toast("success", "Leads generated successfully!");
    //         if (res.data.id) {
    //           navigate(`/leads/edit-new-lead/${res.data.id}`);
    //         }
    //       }, 500);
    //     } else if (res.status === 200) {
    //       Toast("error", res.data.message);
    //       if (res.data.id) {
    //         navigate(`/leads/edit-new-lead/${res.data.id}`);
    //       }
    //       setRefresh(!refresh);
    //     } else {
    //       Toast("error", "Error while uploading");
    //     }
    //   })
    //   .catch((err) => {
    //     CustomErrorResponse("Error", err);
    //   });
  };

  const getName = (lead) => {
    if (lead.fullName) {
      return lead.fullName;
    }
    if (lead.firstName && lead.lastName) {
      return `${lead.firstName} ${lead.lastName}`;
    }
    if (lead.firstName) {
      return lead.firstName;
    }
    if (lead.lastName) {
      return lead.lastName;
    }
    return "N/A";
  };

  const handleHitRequest = async (lClick) => {
    if (!notificationData) {
      return { success: false, error: "No hitRequest or notificationData" };
    }

    notificationData.userId = store?.UserId;
    notificationData.leadClicked = leadClicked;

    try {
      const res = await performRequest(
        "POST",
        "/pushNotifications/post-sm-enquiry-send-notification",
        {
          data: notificationData,
        }
      );
      return { success: true, response: res, flag: true };
    } catch (err) {
      setNotificationData(null);
      return { success: false, error: err, flag: true };
    }
  };

  const handleNotification = (
    title,
    body,
    url,
    email,
    name,
    mobileNumber,
    origin
  ) => {
    // Set notification data for modal display
    if (mobileNumber) {
      setNotificationData({
        title,
        body,
        url,
        email,
        name,
        mobileNumber,
        origin,
      });

      // Timer component:
      setTimeLeft(45); // Reset timer on new notification
      let btn = document.getElementById("opensuccessmodal");
      btn?.click();
    } else {
      return;
    }
  };

  const handleModelClose = () => {
    stopTimer();
    handleHitRequest();
  };

  return (
    <>
      <style>{`
  body.modal-open {
    overflow: auto !important;
    padding-right: 0 !important;
  }
`}</style>
      <CheckedLoggedIn />
      {Role &&
        (Role === process.env.REACT_APP_ROLE_SALLE ||
          Role === process.env.REACT_APP_ROLE_SALLE_ADMIN) && <SideBar />}

      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      ></ToastContainer>

      {/* modal */}
      <button
        className="btn"
        data-bs-toggle="modal"
        data-bs-target="#modal-report-1"
        style={{ display: "none" }}
        id="opensuccessmodal"
      ></button>

      <div
        className="modal"
        id="modal-report-1"
        tabIndex="-1"
        role="dialog"
        data-bs-backdrop="false"
        style={{ background: "transparent", pointerEvents: "none" }}
      >
        <div
          className="modal-dialog modal-sm"
          role="document"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            margin: 0,
            maxWidth: "600px",
            minWidth: "350px",
            pointerEvents: "all",
          }}
        >
          <div
            className="modal-content"
            style={{
              borderRadius: "12px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
            }}
          >
            <div
              className="modal-header"
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "white",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "12px",
                paddingLeft: "20px",
                paddingRight: "10px",
                fontWeight: "bold",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background:
                    "linear-gradient(270deg, #00c6ff, #0072ff, #00ff88, #ff0072)",
                  backgroundSize: "800% 800%",
                  animation: "glowHeader 6s ease infinite",
                  zIndex: 0,
                }}
              ></div>
              <h4
                style={{
                  position: "relative",
                  zIndex: 1,
                  margin: 0,
                  fontWeight: "bold",
                }}
              >
                🚨 Fresh Lead Alert!
              </h4>
              <div style={{ position: "relative", zIndex: 1 }}>
                <Timer />
              </div>
              <button
                type="button"
                className="btn-close  fw-bold"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ position: "relative", zIndex: 1, color: "white" }}
                id="btn-close-1"
                onClick={() => handleModelClose()}
              ></button>
              <button
                type="button"
                className="btn-close  fw-bold visually-hidden"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ position: "relative", zIndex: 1, color: "white" }}
                id="btn-close-2"
              ></button>
            </div>

            {/* Modal Body */}
            <div
              className="modal-body"
              style={{
                position: "relative",
                minHeight: "60px",
                padding: "15px",
              }}
            >
              {notificationData && (
                <div>
                  {greetingWithName || "Hii"}
                  <br />
                  <br />
                  {alert}
                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button
                className="btn btn-primary m-0"
                data-bs-dismiss="modal"
                onClick={() => AddAndAssignLead(notificationData)}
              >
                {btnText}
              </button>
            </div>
            <style>
              {`
          @keyframes glowHeader {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
            </style>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
// import React, { useState, useEffect } from "react";
// import io from "socket.io-client";

// // Connect to the backend using Socket.io
// const socket = io("http://192.168.1.49:4501"); // Adjust the server URL if needed

// function PostForm() {
//   const [post, setPost] = useState("");
//   const [posts, setPosts] = useState([]);

//   // Listen for new posts from the server in real-time
//   useEffect(() => {
//     socket.on("newPost", (newPost) => {
//       setPosts((prevPosts) => [...prevPosts, newPost]);
//     });

//     return () => {
//       socket.off("newPost"); // Clean up on unmount
//     };
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log(post);
//     // Send the post data to the backend using Socket.io
//     socket.emit("newPost", { content: post });

//     // Optionally, send the post to the backend via an HTTP request as well (e.g., to store it in DB)
//     await fetch("http://192.168.1.49:4501/post-new", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ content: post }),
//     }).then((res) => console.log(res));

//     setPost("");
//   };

//   return (
//     <div>
//       <h1>Post Form</h1>
//       <form onSubmit={handleSubmit}>
//         <input
//           type="text"
//           value={post}
//           onChange={(e) => setPost(e.target.value)}
//           placeholder="Enter your post"
//         />
//         <button type="submit">Post</button>
//       </form>

//       <h2>Posts</h2>
//       <ul>
//         {posts.map((p, index) => (
//           <li key={index}>{p.content}</li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default PostForm;
